/* ==========================================================================
   Serene Voyages — theme.js
   Vanilla JS. No dependencies. Initializes on load and on section re-render
   in the Shopify theme editor (shopify:section:load).
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.setAttribute('data-js', '');

  /* ------------------------------------------------------------------
     Reveal on scroll
  ------------------------------------------------------------------ */
  function initReveal(root) {
    var scope = root || document;
    var els = (scope !== document && scope.classList && scope.classList.contains('reveal'))
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('.reveal'));

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) {
      if (!el.classList.contains('is-revealed')) observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Hero slider (home) + destination hero slider
  ------------------------------------------------------------------ */
  function initHero(root) {
    var heroes = (root || document).querySelectorAll('[data-hero]');
    heroes.forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero__slide'));
      if (slides.length === 0) return;

      var prevBtn = hero.querySelector('[data-hero-prev]');
      var nextBtn = hero.querySelector('[data-hero-next]');
      var dotsWrap = hero.querySelector('[data-hero-dots]');
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var duration = parseInt(hero.getAttribute('data-duration') || '6', 10) * 1000;
      var index = 0;
      var timer = null;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (slide, n) {
          slide.classList.toggle('is-active', n === index);
        });
        dots.forEach(function (dot, n) {
          dot.classList.toggle('is-active', n === index);
          dot.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      function start() {
        stop();
        if (autoplay && slides.length > 1) {
          timer = setInterval(function () { show(index + 1); }, duration);
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); start(); });

      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { show(n); start(); });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      // Touch swipe
      var startX = null;
      hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 45) show(delta < 0 ? index + 1 : index - 1);
        startX = null;
        start();
      }, { passive: true });

      show(0);
      start();
    });
  }

  /* ------------------------------------------------------------------
     Destination filter pills (destinations-list)
  ------------------------------------------------------------------ */
  function initFilters(root) {
    var groups = (root || document).querySelectorAll('[data-filter-group]');
    groups.forEach(function (group) {
      var scope = group.closest('.section') || document;
      var cards = scope.querySelectorAll('[data-dest-card]');
      var emptyNote = scope.querySelector('[data-filter-empty]');

      group.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-filter]');
        if (!pill) return;

        group.querySelectorAll('[data-filter]').forEach(function (b) {
          var active = b === pill;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        var value = pill.getAttribute('data-filter').trim().toLowerCase();
        var visible = 0;

        cards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          var match = value === '*' || tags.indexOf(value) !== -1;
          card.classList.toggle('is-hidden', !match);
          if (match) visible++;
        });

        if (emptyNote) emptyNote.hidden = visible > 0;
      });
    });
  }

  /* ------------------------------------------------------------------
     FAQ accordion (single-open mode)
  ------------------------------------------------------------------ */
  function initAccordion(root) {
    var lists = (root || document).querySelectorAll('[data-accordion]');
    lists.forEach(function (list) {
      var items = list.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Gallery lightbox (keyboard + swipe)
  ------------------------------------------------------------------ */
  function initGallery(root) {
    var galleries = (root || document).querySelectorAll('[data-gallery]');
    if (galleries.length === 0) return;

    var lightbox = document.getElementById('Lightbox');
    if (!lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-image]');
    var caption = lightbox.querySelector('[data-lightbox-caption]');
    var items = [];
    var current = -1;
    var lastFocus = null;

    function open(i) {
      current = (i + items.length) % items.length;
      var trigger = items[current];
      img.src = trigger.getAttribute('data-full') || trigger.querySelector('img').src;
      img.alt = (trigger.querySelector('img') || {}).alt || '';
      if (caption) caption.textContent = trigger.getAttribute('data-caption') || img.alt || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lightbox.querySelector('[data-lightbox-close]').focus();
    }

    function close() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    galleries.forEach(function (gallery) {
      var galleryItems = Array.prototype.slice.call(
        gallery.querySelectorAll('[data-gallery-item]')
      );
      galleryItems.forEach(function (trigger, i) {
        items.push(trigger);
        trigger.addEventListener('click', function () {
          lastFocus = trigger;
          open(items.indexOf(trigger));
        });
      });
    });

    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);
    lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function () { open(current - 1); });
    lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function () { open(current + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') open(current - 1);
      if (e.key === 'ArrowRight') open(current + 1);
    });

    var startX = null;
    lightbox.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 45) open(delta < 0 ? current + 1 : current - 1);
      startX = null;
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Quote form: prefill from URL (?destination= &type= &offer=)
  ------------------------------------------------------------------ */
  function initQuoteForm(root) {
    var selects = (root || document).querySelectorAll('select[data-destination-select]');
    if (selects.length === 0) return;

    var forms = [];
    selects.forEach(function (select) {
      var form = select.closest('form');
      if (form && forms.indexOf(form) === -1) forms.push(form);
    });

    var params = (window.URLSearchParams && window.location.search)
      ? new URLSearchParams(window.location.search)
      : null;

    forms.forEach(function (form) {
      if (params) {
        var destination = (params.get('destination') || '').toLowerCase();
        var type = params.get('type') || '';
        var offer = params.get('offer') || '';

        if (destination) {
          var select = form.querySelector('select[data-destination-select]');
          if (select) {
            Array.prototype.forEach.call(select.options, function (option) {
              var slug = (option.getAttribute('data-slug') || option.value).toLowerCase();
              if (slug === destination) select.value = option.value;
            });
          }
        }

        if (type) {
          var typeField = form.querySelector('select[data-type-select]');
          if (typeField && typeField.querySelector('option[value="' + type + '"]')) {
            typeField.value = type;
          }
        }

        if (offer) {
          var message = form.querySelector('textarea[data-message]');
          if (message && !message.value) {
            message.value = 'I am interested in this offer: ' + offer + '.';
          }
        }
      }

      // Serialize structured fields into the contact body before submit so
      // every detail reaches the store owner in a single email.
      form.addEventListener('submit', function () {
        var lines = [];
        form.querySelectorAll('[data-qf]').forEach(function (el) {
          var label = el.getAttribute('data-qf') || '';
          var value = '';
          if (el.type === 'checkbox') {
            value = el.checked ? 'Yes' : 'No';
          } else if (el.tagName === 'SELECT') {
            value = el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : '';
          } else {
            value = el.value ? el.value.trim() : '';
          }
          if (value) lines.push(label + ': ' + value);
        });

        var message = form.querySelector('textarea[data-message]');
        if (message && lines.length) {
          var summary = lines.join('\n');
          if (message.value && message.value.trim()) {
            message.value = summary + '\n\n' + message.value;
          } else {
            message.value = summary;
          }
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Mobile navigation
  ------------------------------------------------------------------ */
  function initNav(root) {
    var docRoot = root || document;
    var toggle = docRoot.querySelector('[data-nav-toggle]');
    var nav = docRoot.querySelector('[data-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Mobile: toggle nested dropdown groups (accordion). Desktop uses hover instead.
    var mobileNav = window.matchMedia('(max-width: 989px)');
    docRoot.querySelectorAll('.nav-drop > .nav-link--drop').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!mobileNav.matches) return;               // desktop: let it navigate
        e.preventDefault();                           // mobile: toggle instead of navigating
        e.stopPropagation();
        var group = trigger.closest('.nav-drop');
        if (!group) return;
        var isOpen = group.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ------------------------------------------------------------------
     Virtual tour interactive slider (vt-slider snippet)
  ------------------------------------------------------------------ */
  function initVtSlider(root) {
    document.querySelectorAll('[data-vt-slider]').forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-vts-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-vts-dot]'));
      var num = slider.querySelector('[data-vts-num]');
      var prev = slider.querySelector('[data-vts-prev]');
      var next = slider.querySelector('[data-vts-next]');
      if (!slides.length) return;
      var cur = 0, timer = null;

      function show(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-current', n === cur); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === cur); });
        if (num) num.textContent = String(cur + 1);
      }
      function start() { stop(); timer = setInterval(function () { show(cur + 1); }, 4200); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { show(cur - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(cur + 1); restart(); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); restart(); }); });
      if (num) num.textContent = '1';
      start();

      function restart() { start(); }
      // pause on hover
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
    });
  }

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  function initAll(root) {
    var inits = [initReveal, initHero, initFilters, initAccordion, initGallery, initQuoteForm, initNav, initQuiz, initEstimator, initSocialPopup, initVtSlider];
    inits.forEach(function (fn) {
      try { fn(root); } catch (e) { if (window.console && console.error) console.error('theme init error:', e); }
    });
  }

  /* ------------------------------------------------------------------
     Destination quiz (destination-quiz section)
  ------------------------------------------------------------------ */
  function initQuiz(root) {
    var quiz = (root || document).querySelector('[data-quiz]');
    if (!quiz || quiz.getAttribute('data-quiz-ready')) return;
    quiz.setAttribute('data-quiz-ready', '1');

    var container = quiz.querySelector('[data-quiz-destinations]');
    var dests = [];
    try { dests = JSON.parse(container ? container.textContent : '[]'); } catch (e) { dests = []; }
    var quoteUrl = quiz.getAttribute('data-quiz-quote') || '/';
    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step]'));
    var progress = quiz.querySelector('[data-quiz-progress]');
    var resultEl = quiz.querySelector('[data-quiz-result]');
    var stepsWrap = quiz.querySelector('[data-quiz-steps]');
    var answers = {};
    var stepIndex = 0;

    function toLatin(s) {
      var map = { '\u0660': '0', '\u0661': '1', '\u0662': '2', '\u0663': '3', '\u0664': '4', '\u0665': '5', '\u0666': '6', '\u0667': '7', '\u0668': '8', '\u0669': '9' };
      return String(s || '').replace(/[\u0660-\u0669]/g, function (d) { return map[d]; });
    }

    function showStep(i) {
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      if (progress) progress.style.width = ((i + 1) / steps.length * 100) + '%';
    }

    function score() {
      var ranked = dests.map(function (d) {
        var s = Math.random() * 0.05;
        var tags = (d.tags || []).map(function (t) { return String(t).toLowerCase(); });
        if (answers.tag && tags.indexOf(String(answers.tag).toLowerCase()) !== -1) s += 3;
        var p = Number(d.price) || 0;
        if (answers.price === 'low' && p < 500) s += 2;
        if (answers.price === 'mid' && p >= 500 && p <= 900) s += 2;
        if (answers.price === 'high' && p > 900) s += 2;
        var m = toLatin(d.days).match(/\d+/);
        var minDays = m ? parseInt(m[0], 10) : 7;
        if (answers.days === 'short' && minDays <= 4) s += 1;
        if (answers.days === 'mid' && minDays >= 5 && minDays <= 7) s += 1;
        if (answers.days === 'long' && minDays >= 8) s += 1;
        return { d: d, s: s };
      });
      ranked.sort(function (a, b) { return b.s - a.s; });
      return ranked[0] ? ranked[0].d : null;
    }

    function renderResult(win) {
      if (!win || !resultEl) return;
      var h = '<div class="quiz__result-card">';
      if (win.image) h += '<div class="quiz__result-img"><img src="' + win.image + '" alt="' + win.name + '" loading="lazy"></div>';
      h += '<div class="quiz__result-body"><span class="eyebrow">وجهتك المقترحة</span><h3>' + win.name + '</h3>';
      if (win.desc) h += '<p>' + win.desc + '</p>';
      if (win.price) h += '<div class="quiz__result-price">تبدأ الرحلات من <strong>' + (win.currency || '$') + win.price + '</strong> للشخص</div>';
      h += '<div class="quiz__result-actions">';
      h += '<a class="btn btn--primary" href="' + (win.url || '#') + '">عرض الوجهة</a>';
      h += '<a class="btn btn--outline" href="' + quoteUrl + '?destination=' + encodeURIComponent(win.slug || win.name) + '&type=trip">اطلب تقديرًا</a>';
      h += '</div><button type="button" class="quiz__restart" data-quiz-restart>إعادة الاختبار</button></div></div>';
      resultEl.innerHTML = h;
      resultEl.hidden = false;
      if (stepsWrap) stepsWrap.hidden = true;
      if (progress) progress.style.width = '100%';
      var rb = resultEl.querySelector('[data-quiz-restart]');
      if (rb) rb.addEventListener('click', function () {
        answers = {}; stepIndex = 0;
        resultEl.hidden = true;
        if (stepsWrap) stepsWrap.hidden = false;
        showStep(0);
      });
    }

    quiz.querySelectorAll('.quiz__answer').forEach(function (btn) {
      btn.addEventListener('click', function () {
        ['tag', 'price', 'days'].forEach(function (k) {
          var v = btn.getAttribute('data-' + k);
          if (v) answers[k] = v;
        });
        stepIndex++;
        if (stepIndex >= steps.length) renderResult(score());
        else showStep(stepIndex);
      });
    });

    showStep(0);
  }

  /* ------------------------------------------------------------------
     Cost estimator (cost-estimator section)
  ------------------------------------------------------------------ */
  function initEstimator(root) {
    var est = (root || document).querySelector('[data-estimator]');
    if (!est) return;
    var destSel = est.querySelector('[data-est-dest]');
    if (!destSel) return;
    var adultsEl = est.querySelector('[data-est-adults]');
    var childrenEl = est.querySelector('[data-est-children]');
    var hotelSel = est.querySelector('[data-est-hotel]');
    var perEl = est.querySelector('[data-est-per]');
    var totalEl = est.querySelector('[data-est-total]');
    var visaEl = est.querySelector('[data-est-visa]');
    var cta = est.querySelector('[data-est-cta]');
    var quoteUrl = est.getAttribute('data-estimator-quote') || '/';

    function update() {
      var opt = destSel.options[destSel.selectedIndex];
      if (!opt) return;
      var price = parseFloat(opt.getAttribute('data-price') || '0');
      var visa = parseFloat(opt.getAttribute('data-visa') || '0');
      var currency = opt.getAttribute('data-currency') || '$';
      var slug = opt.getAttribute('data-slug') || '';
      var mult = parseFloat(hotelSel && hotelSel.value ? hotelSel.value : '1');
      var adults = Math.max(1, parseInt(adultsEl && adultsEl.value ? adultsEl.value : '1', 10));
      var children = Math.max(0, parseInt(childrenEl && childrenEl.value ? childrenEl.value : '0', 10));
      var per = Math.round(price * mult);
      var total = Math.round(per * adults + per * 0.5 * children);
      if (perEl) perEl.textContent = currency + per;
      if (totalEl) totalEl.textContent = currency + total;
      if (visaEl) visaEl.textContent = (visa > 0 ? currency + visa : 'حسب الطلب');
      if (cta) cta.href = quoteUrl + '?destination=' + encodeURIComponent(slug) + '&type=trip';
    }

    est.addEventListener('change', update);
    update();
  }

  /* ------------------------------------------------------------------
     Social follow popup (once per 3 days)
  ------------------------------------------------------------------ */
  function initSocialPopup(root) {
    var popup = (root || document).querySelector('[data-social-popup]');
    if (!popup) return;
    var KEY = 'sv-social-popup-shown';
    try {
      var last = localStorage.getItem(KEY);
      if (last && (Date.now() - parseInt(last, 10)) < 24 * 60 * 60 * 1000) return;
    } catch (e) { /* storage unavailable */ }
    var shown = false;
    function open() {
      if (shown) return;
      shown = true;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      popup.hidden = true;
      document.body.style.overflow = '';
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    popup.querySelectorAll('[data-social-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) close();
    });
    setTimeout(open, 3000);
  }

  function boot() {
    initAll(document);
    document.documentElement.classList.add('js-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-initialize inside a section after it re-renders in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
